import { useEffect, useRef, useState, RefObject } from 'react'
import Input from '../../Input'
import TouchableOpacity from '../../TouchableOpacity'
import Text from '../../Text'
import { editInstance } from '../../../api/endpoints'
import type { Preset } from '@expostreamer/shared-types'
import styles from './style'

export interface EditInstanceViewHandle {
  show: (preset: Preset) => void
}

interface EditInstanceViewModalProps {
  ref?: RefObject<EditInstanceViewHandle | null>
}

function EditInstanceViewModal({ ref }: EditInstanceViewModalProps) {
  const [preset, setPreset] = useState<Preset | null>(null)
  const [showEditInstanceSelectModal, setShowEditInstanceSelectModal] = useState(false)
  const textAreaRef = useRef<HTMLTextAreaElement>(null)
  const [onClickHandler, setOnClickHandler] = useState<((preset: Preset) => void) | null>(null)

  useEffect(() => {
    if (!ref) return

    ref.current = {
      show: preset => {
        setPreset(preset)
        setShowEditInstanceSelectModal(true)
      },
    }
  }, [ref])

  return showEditInstanceSelectModal ? (
    <div style={styles.container}>
      <div
        style={styles.backdrop}
        onClick={() => setShowEditInstanceSelectModal(!showEditInstanceSelectModal)}
      />
      {preset?.name ? (
        <Input
          style={styles.elevated}
          value={preset?.name}
        />
      ) : null}
      {preset?.processParams.length ? (
        <textarea
          ref={textAreaRef}
          style={styles.elevated}
          rows={4}
          cols={50}
          defaultValue={preset?.processParams.reduce(
            (accumulator, currentValue) =>
              accumulator + (accumulator.length ? ' ' : '') + currentValue,
            ''
          )}
        />
      ) : null}
      <div style={styles.elevated}>
        <TouchableOpacity
          onClick={() => {
            if (!textAreaRef.current?.value.length) return
            editInstance({ ...preset, processParams: textAreaRef.current.value })
          }}
        >
          <Text>SPEICHERN</Text>
        </TouchableOpacity>
      </div>
    </div>
  ) : null
}

export default EditInstanceViewModal
